import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import InputMask from 'react-input-mask';
import Select from 'react-select';
import TeamTrainingMatterLineScheduleInstructorModal from './TeamTrainingMatterLineScheduleInstructorModal';


class TeamTrainingMatterLineScheduleInstructorModalLine extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      refresh: 0,
      team_id: null,
      local: '',
      class_number: '',
      instructor_date_start: null,
      instructor_date_finish: null,
      lista_assuntos: [],
      lista_instrutores: [],
      matter_subject_id: null,
      staff_id: null,
      instrutor: {},
    };
    this.export = this.export.bind(this);
    this.editarinstrutor = this.editarinstrutor.bind(this);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof newProps.instrutor.id !== 'undefined' && this.state.loaded === 0 || this.state.refresh === 0) {
      this.setState({instrutor: newProps.instrutor});
      this.setState({matter_subject_id: newProps.instrutor.matter_subject_id});
      this.setState({staff_id: newProps.instrutor.staff_id});
      this.setState({local: newProps.instrutor.local});
      this.setState({class_number: newProps.instrutor.class_number});
      this.setState({instructor_date_start: newProps.instrutor.instructor_date_start_str});
      this.setState({instructor_date_finish: newProps.instrutor.instructor_date_finish_str});
      this.setState({loaded: 1});
      this.setState({refresh: 0});
    }
    if(Array.isArray(newProps.lista_assuntos)) {
      this.setState({lista_assuntos: newProps.lista_assuntos});
    }
    if(Array.isArray(newProps.lista_instrutores)) {
      this.setState({lista_instrutores: newProps.lista_instrutores});
    }
  }
  export(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var self = this;
    var url = "/exportar/programacao/aula/" + event.currentTarget.value;
    var header = this.props.RequestApi.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.props.RequestApi.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
        }
        self.props.handleAlert("", "", 'closed');
      });
    });
  }

  editarinstrutor() {
    this.setState({refresh: 1});
    this.props.handleAlert('', '', 'open');
    var datasave = {
      team_training_matter_id: this.state.instrutor.team_training_matter_id,
      id: this.state.instrutor.id,
      staff_id: this.state.staff_id,
      local: this.state.local,
      class_number: this.state.class_number,
      matter_subject_id: this.state.matter_subject_id,
      instructor_date_start: this.state.instructor_date_start,
      instructor_date_finish: this.state.instructor_date_finish,
    };
    var header = this.props.RequestApi.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/turma/treinamento/materia/instrutor', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.props.RequestApi.validate(responseJson, 'alert');
        self.props.refreshData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  deletar (team_training_matter_staff_id) {
    var confirm = window.confirm('Tem certeza que gostaria de deletar esse instrutor?');
    if (confirm) {
    this.props.handleAlert('', '', 'open');
      var header = this.props.RequestApi.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/turma/treinamento/materia/instrutor/' + team_training_matter_staff_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.props.RequestApi.validate(responseJson, 'alert');
        self.props.refreshData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }


  render() {
    var self = this;
    if (typeof this.state.instrutor.id !== 'undefined') {
      return (
          <tr>
            <td>
              <Select
                className="small-font-input"
                name="staff_id"
                value={this.state.staff_id}
                searchable={true}
                placeholder={'Selecionar instrutor'}
                onChange={this.handleSelectChange.bind(this, 'staff_id')}
                options={this.state.lista_instrutores}
              />
            </td>
            <td>
              <Select
                className="small-font-input"
                name="matter_subject_id"
                value={this.state.matter_subject_id}
                searchable={true}
                placeholder={'Selecionar assunto'}
                onChange={this.handleSelectChange.bind(this, 'matter_subject_id')}
                options={this.state.lista_assuntos}
              />
            </td>
            <td>
              <input type="text" name="local" className="form-control" placeholder="Local" value={this.state.local} onChange={this.handleChange.bind(this, 'local')} />
            </td>
            <td>
              <input type="text" name="class_number" className="form-control" placeholder="Ńúmero da sala" value={this.state.class_number} onChange={this.handleChange.bind(this, 'class_number')} />
            </td>
            <td>
              <InputMask required value={this.state.instructor_date_start}  maskChar={null} name="instructor_date_start " mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'instructor_date_start')} placeholder="dd/mm/yyyy hh:mm" />
            </td>
            <td>
              <InputMask required value={this.state.instructor_date_finish}  maskChar={null} name="instructor_date_finish " mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'instructor_date_finish')} placeholder="dd/mm/yyyy hh:mm" />
            </td>

            <td>
              <div className="btn-group">
                <button className="btn btn-primary btn-sm" value={1} onClick={() => {this.editarinstrutor()}}>
                    <i className="fa fa-fw fa-save"></i>
                </button>
                <button className="btn btn-info btn-sm" value={this.state.instrutor.id} onClick={this.export}><i className="fa fa-fw fa-file-pdf-o"></i></button>
                <button className="btn btn-sm btn-danger" value={this.state.instrutor.id} onClick={() => {this.deletar(this.state.instrutor.id);}}><i className="fa fa-fw fa-trash"></i></button>
              </div>
            </td>
          </tr>
      );
    } else {
      return(
        <tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
      );
    }
  }
}

export default TeamTrainingMatterLineScheduleInstructorModalLine;



// WEBPACK FOOTER //
// ./src/Components/Teams/Elements/TeamTrainingMatterLineScheduleInstructorModalLine.js